import { defineStore } from 'pinia'

interface ModalPropsPayload<T = any> {
  name: string
  data: T
}

interface ModalStoreState {
  modalProps: Record<string, any>
  renderedModals: string[]
  modals: Record<string, boolean>
}

export const useVueNextModalStore = defineStore('vueNextModal', {
  state: (): ModalStoreState => ({
    modalProps: {},
    renderedModals: [],
    modals: {},
  }),
  getters: {
    modalPropsByName: (state: ModalStoreState) => (name: string) => state.modalProps[name],
    isModalVisible: (state: ModalStoreState) => (name: string) => Boolean(state.modals[name]),
  },
  actions: {
    renderModal(name: string) {
      if (this.renderedModals.includes(name)) return
      this.renderedModals = [...this.renderedModals, name]
    },
    openModal(payload: ModalPropsPayload) {
      this.modals = { ...this.modals, [payload.name]: true }
      this.modalProps = { ...this.modalProps, [payload.name]: payload.data }
    },
    closeModal(name: string) {
      this.modals = { ...this.modals, [name]: false }
      this.modalProps = { ...this.modalProps, [name]: {} }
    },
  },
})

export type VueNextModalStore = ReturnType<typeof useVueNextModalStore>
